import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { complianceEffects } from 'src/app/compliance/store/effects/compliance-effects';
import { complianceReducers } from 'src/app/compliance/store/reducers';
import { complianceFeatureKey } from 'src/app/compliance/store/selectors';

export const provideComplianceStore = (): EnvironmentProviders[] => [
    provideState(complianceFeatureKey, complianceReducers),
    provideEffects(complianceEffects)
];
